import React from 'react';
import { toast } from 'react-toastify';
import ContenidoToast, { TITULOS } from './ContenidoToast';

/**
 * Única vía para mostrar toasts en el ERP (el contenedor se monta una sola vez en App.js).
 *
 *   notificar.exito('Packing list creado');
 *   notificar.error(error.message);
 *   notificar.aviso('Seleccione al menos una NF.');
 *   notificar.info('Se cargaron 3 registros.');
 *
 * El título es automático según el tipo; opciones: { titulo, toastId, autoClose }.
 * `toastId` evita duplicados mientras el mismo toast siga visible.
 */
const emitir = (tipo, mensaje, opciones = {}) => {
  const { titulo, ...resto } = opciones;
  const texto = mensaje === undefined || mensaje === null ? '' : String(mensaje);
  return toast(
    <ContenidoToast tipo={tipo} titulo={titulo || TITULOS[tipo]} mensaje={texto} />,
    { icon: false, ...resto }
  );
};

export const notificar = {
  exito: (mensaje, opciones) => emitir('exito', mensaje, opciones),
  error: (mensaje, opciones) => emitir('error', mensaje, opciones),
  aviso: (mensaje, opciones) => emitir('aviso', mensaje, opciones),
  info: (mensaje, opciones) => emitir('info', mensaje, opciones),
  /** Cierra un toast por `toastId`, o todos si no se indica. */
  cerrar: (toastId) => toast.dismiss(toastId),
};

export default notificar;
